<ng-template
  #labelTemplate
  let-item
  let-clear="clear"
  >
  <span class="ng-value-icon left" (click)="clear(item)">×</span>
  <span class="ng-value-label">{{ item.name }}</span>
</ng-template>

<ng-template
  #optionTemplate
  let-item
  let-search="search"
  >
  <div
    [title]="item.name"
    class="ng-option-label ellipsis"
    [ngStyle]="{ 'padding-left.px': item.numberOfAncestors * 16 }"
    [opSearchHighlight]="search"
  >{{ item.name }}</div>
  @if (item.disabled && item.disabledReason) {
    <div
      [title]="item.disabledReason"
      class="ng-option-label ellipsis"
      [ngStyle]="{ 'padding-left.px': item.numberOfAncestors * 16 }"
    >{{ item.disabledReason }}</div>
  }
</ng-template>
